/**
 * Viewer 도메인 Query Key 관리
 */
export const VIEWER_QUERY_KEY_MAP = {
  /**
   * 뷰어 정보 조회
   * Origin: fetchViewerInfo
   */
  viewerInfo: (variables: {seriesId: number; productId: number}) => [
    'viewerInfo',
    variables,
  ],
  /**
   * 뷰어엔드 조회
   * Origin: fetchViewerEnd
   */
  viewerEnd: (variables: {seriesId: number; productId: number}) => [
    'viewerEnd',
    variables,
  ],
} as const;

/**
 * Viewer 도메인 Mutation Key 관리
 */
export const VIEWER_MUTATION_KEY_MAP = {
  /**
   * 마지막 페이지 저장
   * Origin: useLastPageMutation (getKey 없음)
   */
  lastPage: 'lastPage',
  /**
   * 페이지 오픈 로그 저장
   * Origin: useOpenPageMutation (getKey 없음)
   */
  openPage: 'openPage',
} as const;
